// extracted by mini-css-extract-plugin
module.exports = {"StrollerDetailRating":"xh_a bhe_a bhe_x","StrollerDetailRating__muted":"xh_b bhe_fi"};